import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

const UnProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  console.log('[UnProtectedRoute] ========== Component rendered ==========');
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);

  console.log('[UnProtectedRoute] isAuthenticated:', isAuthenticated, 'user:', user);

  if (!isAuthenticated) {
    console.log('[UnProtectedRoute] Not authenticated, rendering children');
    return <>{children}</>;
  }

  // If admin is already logged in, redirect to families
  if (user?.role === 'admin' || user?.role === 'sub-admin') {
    console.log('[UnProtectedRoute] Already authenticated, redirecting to /families');
    return <Navigate to="/families" replace />;
  }

  // Otherwise redirect to home
  console.log('[UnProtectedRoute] Authenticated but not admin, redirecting to /');
  return <Navigate to="/" replace />;
};

export default UnProtectedRoute;
